export interface DateGroupHeadingProps {
  date: Date;
  isToday?: boolean;
  isPast?: boolean;
  className?: string;
}

const DAY_NAMES = [
  'Sunday',
  'Monday',
  'Tuesday',
  'Wednesday',
  'Thursday',
  'Friday',
  'Saturday',
];
const MONTH_ABBR = [
  'Jan',
  'Feb',
  'Mar',
  'Apr',
  'May',
  'Jun',
  'Jul',
  'Aug',
  'Sep',
  'Oct',
  'Nov',
  'Dec',
];

export function DateGroupHeading({
  date,
  isToday = false,
  isPast = false,
  className = '',
}: DateGroupHeadingProps) {
  const month = MONTH_ABBR[date.getMonth()];
  const day = date.getDate();
  const dayName = DAY_NAMES[date.getDay()];

  return (
    <h3
      className={[
        'text-base font-bold',
        isPast ? 'text-muted-foreground' : 'text-primary',
        className,
      ]
        .filter(Boolean)
        .join(' ')}
    >
      {month} {day}
      {isToday && <span> &middot; Today</span>}
      <span> &middot; {dayName}</span>
    </h3>
  );
}
